<div class="w-full flex flex-col gap-4">
  <ngx-form-factory
    [form]="form"
    [formFields]="fieldsService.forgotPasswordFields"
    (keydown.enter)="onSendEmail()"
  />
  <div class="flex flex-row items-center justify-between w-full gap-4">
    <a [routerLink]="['/auth/login']">{{ 'auth.returnToLogin' | translate }}</a>
    <app-button
      [text]="'auth.sendEmail' | translate"
      (click)="onSendEmail()"
      size="small"
    ></app-button>
  </div>
</div>
